export default __webpack_public_path__ + "static/media/ci1.d43eb269.jpg";